import { API_PREFIX } from "app/constants";
import to from "core/util/fetch/awaitToJs";
import superagent from "superagent";

const cancellationUriPrefix = `${API_PREFIX}/vehicle-cancellation`;

const isFeasible = async (idObject) => {
    return await to(superagent.get(`${cancellationUriPrefix}/${idObject}/is-feasible`));
};

const createCancellation = async (idObject, data) => {
    return await to(
        superagent.post(`${cancellationUriPrefix}/${idObject}/create`).send(data).set("Content-Type", "application/json").accept("json"),
    );
};

const submitCancellation = async (idObject, idChange, data) => {
    return await to(
        superagent
            .post(`${cancellationUriPrefix}/${idObject}/submit/${idChange}`)
            .send(data)
            .set("Content-Type", "application/json")
            .accept("json"),
    );
};

const completeCancellation = async (idObject, idChange, data) => {
    return await to(
        superagent
            .post(`${cancellationUriPrefix}/${idObject}/complete/${idChange}`)
            .send(data)
            .set("Content-Type", "application/json")
            .accept("json"),
    );
};

const getCancellationReasons = async (idObject, changeSheetId) => {
    return await to(superagent.get(`${cancellationUriPrefix}/${idObject}/cancellation-reason/${changeSheetId}`));
};

const getCancellationAttachments = async (idObject, changeSheetId, vehicleCancellationReason) => {
    return await to(
        superagent.get(`${cancellationUriPrefix}/${idObject}/cancellation-attachments/${changeSheetId}/${vehicleCancellationReason}`),
    );
};

export default {
    isFeasible,
    createCancellation,
    submitCancellation,
    completeCancellation,
    getCancellationReasons,
    getCancellationAttachments,
};
